import ErrorBoundary from "components/ErrorBoundary";
import { noop } from "shared/functions/";

const ErrorPageTct = () => {
    return (
        <ErrorBoundary
            error={new Error("Failed to open TCT")}
            resetError={noop}
        />
    );
};

export default ErrorPageTct;
